import { render } from "./SeasonalDemand.component.vue?vue&type=template&id=fafa22f4&scoped=true"
import script from "./SeasonalDemand.component.vue?vue&type=script&lang=js"
export * from "./SeasonalDemand.component.vue?vue&type=script&lang=js"

import "./SeasonalDemand.component.vue?vue&type=style&index=0&id=fafa22f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafa22f4"]])

export default __exports__